export default __webpack_public_path__ + "static/media/SLIDE_CAMELLON_3.80333ebd.jpg";